import { call, put } from "redux-saga/effects";
import { API_METHODS, ENDPOINTS } from "../../../endpoint";
import { apiRequest } from "../../../../Utils/axiosApi";
import { Actions } from "../../../constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";

export function* apiFetchSitesRestores(data) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/${
        data.siteId
      }/restores?stagingDomainName=${
        data?.stagingDomainName ? data?.stagingDomainName : ""
      }`,
      method: API_METHODS.GET,
    });
    yield put({
      type: Actions.SET_SITES_RESTORES,
      data: result.data,
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetBackup(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.AWS}/getBackups?siteId=${
        action.data.siteId
      }&stagingDomainName=${
        action.data.stagingDomainName ? action.data.stagingDomainName : ""
      }&backupType=All`,
      method: API_METHODS.GET,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_BACKUP_DETAILS,
        data: result.data,
      });
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetOndemandBackup(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.AWS}/createOnDemandBackups?note=${action.data.note}&siteId=${action.data.siteId}&stagingDomainName=${action.data.stagingDomainName}`,
      method: API_METHODS.POST,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
    } else {
      action.meta?.onError();
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiSiteRestore(action) {
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.POST,
      url: `${ENDPOINTS.SITE_DETAILS}/restoreSite`,
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      return result;
    } else {
      action.meta.Error();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

// EBS (v2) sites: backups are EBS snapshots, same {backupList, onDemandBackupList} shape
export function* apiGetEbsBackup(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/ebsBackups?siteId=${action.data.siteId}&backupType=All`,
      method: API_METHODS.GET,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_EBS_BACKUP_DETAILS,
        data: result.data,
      });
      return result;
    } else {
      // keep the table out of its loading state: it shows its empty state instead of an error
      getStore().dispatch({
        type: Actions.SET_EBS_BACKUP_DETAILS,
        data: { backupList: [], onDemandBackupList: [] },
      });
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    getStore().dispatch({
      type: Actions.SET_EBS_BACKUP_DETAILS,
      data: { backupList: [], onDemandBackupList: [] },
    });
    return { isApiSuccessful: false, data: err };
  }
}

// 202 with status NOT_EXECUTED: the request is validated but the restore job is not run yet
export function* apiEbsSiteRestore(action) {
  let result;
  try {
    result = yield call(apiRequest, {
      method: API_METHODS.POST,
      url: `${ENDPOINTS.SITE_DETAILS}/restoreEbsBackup`,
      data: action.data,
    });
  } catch (err) {
    action.meta?.onError?.();
    return { isApiSuccessful: false, data: err };
  }
  if (result?.isApiSuccessful) {
    action.meta?.onSuccess?.(result.data);
    return result;
  }
  action.meta?.onError?.(result?.response?.data?.errorMessage);
  return { isApiSuccessful: false, data: null };
}

export function* apiEbsCreateBackup(action) {
  let result;
  try {
    result = yield call(apiRequest, {
      method: API_METHODS.POST,
      url: `${ENDPOINTS.SITE_DETAILS}/ebsBackups?siteId=${action.data.siteId}&note=${encodeURIComponent(action.data.note || "")}`,
    });
  } catch (err) {
    action.meta?.onError?.();
    return { isApiSuccessful: false, data: err };
  }
  if (result?.isApiSuccessful) {
    action.meta?.onSuccess?.(result.data);
    return result;
  }
  action.meta?.onError?.(result?.response?.data?.errorMessage);
  return { isApiSuccessful: false, data: null };
}

export function* apiSiteBackupDownload(action) {
  try {
    const result = yield call(apiRequest, {
      method: "GET",
      url: `/AWS/downloadBackup?key=${action.data.key}`,
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiTagName(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/addTag?restoreId=${action.data.restoreId}&siteId=${action.data.siteId}&tagName=${action.data.tagName}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apilabelName(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/updateBackupLabel?fileExplorerDetailsId=${action.data.fileExplorerDetailsId}&siteId=${action.data.siteId}&label=${action.data.label}`,
      method: "PUT",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
